var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ statusNotAllow: _vm.isShow },attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"warnWrapNotify"},[_vm._v(_vm._s(_vm.mes))]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }